const BirthdayCupcake = ({ className }: { className?: string }) => (
  <svg
    className={className}
    fill="none"
    height="150"
    viewBox="0 0 151 150"
    width="151"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_9_78"
        x1="45.7125"
        x2="105.074"
        y1="70.9234"
        y2="70.9234"
      >
        <stop offset="0.23" stopColor="#FF6F55" />
        <stop offset="1" stopColor="#FF6FA5" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_9_78"
        x1="47.9795"
        x2="101.617"
        y1="106.569"
        y2="106.569"
      >
        <stop offset="0.3" stopColor="#FFC900" />
        <stop offset="1" stopColor="#FF6F55" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_9_78"
        x1="72.5265"
        x2="78.2605"
        y1="54.5829"
        y2="54.5829"
      >
        <stop stopColor="#009FC4" />
        <stop offset="0.74" stopColor="#00B08E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_9_78"
        x1="71.326"
        x2="79.4604"
        y1="32.2109"
        y2="32.2109"
      >
        <stop offset="0.3" stopColor="#FFC900" />
        <stop offset="1" stopColor="#FF6F55" />
      </linearGradient>
    </defs>
    <path
      d="M88.6102 61.2709C88.641 61.3427 88.8154 61.7838 88.8769 61.8146C88.9487 61.8453 90.2515 61.8351 90.4771 61.8556C91.9953 62.0095 93.5134 62.4813 94.8366 63.2404C97.1446 64.5636 99.0731 66.9126 99.7193 69.5181C99.7911 69.8258 99.8527 70.1438 99.9347 70.4515C100.007 70.7388 100.007 71.0157 100.058 71.3029C100.232 72.3492 100.109 73.5186 99.9142 74.5444C99.7911 75.1701 99.5449 75.765 99.2885 76.3497C99.8014 76.7293 100.366 77.037 100.889 77.4165C102.202 78.3808 103.34 79.7655 104.11 81.1914C104.325 81.5812 104.469 81.9915 104.612 82.412C104.735 82.7608 104.869 83.1608 104.93 83.5301L105.002 83.8891C105.074 84.2379 105.064 84.5867 105.064 84.9457C105.064 85.2021 105.084 85.4688 105.043 85.7253C104.776 87.4896 104.017 89.1616 102.715 90.4028C102.468 90.6387 102.181 90.8439 101.914 91.0593C101.853 91.1106 101.699 91.2029 101.658 91.2644C101.627 91.3157 101.607 91.4593 101.596 91.5106L49.0668 91.1516C49.0155 91.0182 48.6565 90.7823 48.5231 90.69C47.8359 90.1566 47.2204 89.4591 46.7793 88.7103C45.8048 87.0383 45.4151 85.1611 45.9279 83.2737C46.7691 80.1553 49.0052 77.7755 51.7646 76.1959C51.662 75.9804 51.5184 75.7958 51.4158 75.5804C51.2722 75.3034 51.1594 74.9752 51.0568 74.6777C50.3285 72.38 50.6978 69.7233 51.7851 67.5999C53.375 64.4918 56.4626 62.2659 59.9502 61.8761L60.8426 61.4658C62.5352 60.5016 64.043 59.0758 64.9047 57.3114C65.6432 55.8138 65.5304 54.2752 65.3971 52.6647C64.956 47.5564 70.4849 52.2852 71.9825 53.4956C74.1674 55.2496 77.1729 52.3467 79.645 53.6494C81.2965 54.5213 83.0198 55.2496 84.8046 55.7728C85.8304 56.0702 88.364 60.676 88.8462 61.8146"
      fill="url(#paint0_linear_9_78)"
    />
    <path
      d="M101.617 90.6593C101.371 90.8952 101.084 91.1004 100.817 91.3158C100.755 91.3671 100.602 91.4594 100.561 91.521C100.53 91.5723 100.509 91.7159 100.499 91.7671C100.437 92.239 100.263 92.7109 100.13 93.1725C99.8732 94.0854 99.6271 94.9983 99.3501 95.9113C98.6526 98.25 98.0166 100.599 97.3396 102.948C97.0524 103.953 96.8062 104.979 96.5292 105.995C95.8522 108.487 95.1547 110.98 94.4367 113.462C94.2007 114.283 93.9751 115.114 93.7597 115.934C93.5955 116.539 93.4622 117.165 93.2468 117.76C92.8672 118.796 92.2415 119.699 91.4619 120.468C90.5798 121.34 89.2976 122.038 88.0769 122.304C87.2563 122.489 86.3433 122.479 85.5022 122.479C84.62 122.479 83.7379 122.479 82.8455 122.479C79.9836 122.479 77.1217 122.479 74.2598 122.468C71.7159 122.499 69.1617 122.448 66.6178 122.448C65.4894 122.448 64.3611 122.479 63.2327 122.479C62.2788 122.479 61.3145 122.479 60.3811 122.233C58.5347 121.75 56.8524 120.581 55.8472 118.94C55.1804 117.852 54.9445 116.57 54.6163 115.36C54.3085 114.242 54.0008 113.124 53.6828 111.995C53.0263 109.646 52.4211 107.287 51.7544 104.948C51.1492 102.815 50.5234 100.671 49.9388 98.527C49.4874 96.896 49.0053 95.2753 48.5437 93.6443C48.4001 93.1417 48.2565 92.639 48.1231 92.1262C48.0616 91.8902 48.0308 91.6338 47.9488 91.3979"
      fill="url(#paint1_linear_9_78)"
    />
    <path
      d="M49.3028 91.1516L101.484 91.5209"
      stroke="#832669"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3.00425"
    />
    <path
      d="M60.8117 91.2338L67.4074 122.489"
      stroke="#832669"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3.00425"
    />
    <path
      d="M89.9743 91.7979L83.3786 122.489"
      stroke="#832669"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3.00425"
    />
    <path
      d="M75.3982 92.0235V122.489"
      stroke="#832669"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3.00425"
    />
    <path
      d="M89.3693 62.0813C91.2362 75.324 66.6998 85.8381 61.3145 85.8381"
      stroke="#832669"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3.00425"
    />
    <path
      d="M88.6104 61.5377C88.6411 61.6095 88.8155 62.0506 88.8771 62.0814C88.9489 62.1121 90.2516 62.1019 90.4773 62.1224C91.9954 62.2763 93.5135 62.7481 94.8368 63.5072C97.1448 64.8304 99.0732 67.1794 99.7194 69.7849C99.7912 70.0926 99.8528 70.4106 99.9349 70.7183C100.007 71.0056 100.007 71.2825 100.058 71.5697C100.232 72.616 100.109 73.7854 99.9143 74.8112C99.7912 75.4369 99.5451 76.0318 99.2886 76.6165C99.8015 76.9961 100.366 77.3038 100.889 77.6833C102.151 78.6065 103.238 79.9093 104.007 81.2633C104.233 81.6633 104.407 82.0941 104.571 82.5352C104.715 82.925 104.869 83.3661 104.941 83.7867L105.012 84.1457C105.094 84.5252 105.074 84.9048 105.084 85.2945C105.084 85.551 105.084 85.8177 105.043 86.0741C104.766 87.7974 104.007 89.4387 102.725 90.6593C102.479 90.8953 102.192 91.1004 101.925 91.3158C101.863 91.3671 101.709 91.4594 101.668 91.521C101.638 91.5723 101.617 91.7159 101.607 91.7672C101.545 92.239 101.371 92.7109 101.238 93.1725C100.981 94.0854 100.735 94.9983 100.458 95.9113C99.7605 98.25 99.1245 100.599 98.4475 102.948C98.1603 103.953 97.9141 104.979 97.6371 105.995C96.9601 108.487 96.2626 110.98 95.5446 113.462C95.3086 114.283 95.083 115.114 94.8675 115.934C94.7034 116.539 94.5701 117.165 94.3547 117.76C93.9751 118.796 93.3494 119.699 92.5698 120.468C91.6877 121.34 90.4055 122.038 89.1848 122.304C88.3642 122.489 87.4512 122.479 86.6101 122.479C85.7279 122.479 84.8458 122.479 83.9534 122.479C81.0915 122.479 78.2296 122.479 75.3677 122.468C72.8238 122.499 70.2696 122.448 67.7257 122.448C66.5973 122.448 65.469 122.479 64.3406 122.479C63.3867 122.479 62.4224 122.479 61.489 122.233C59.6426 121.75 57.9603 120.581 56.9551 118.94C56.2883 117.852 56.0524 116.57 55.7242 115.36C55.4164 114.242 55.1087 113.124 54.7907 111.995C54.1342 109.646 53.529 107.287 52.8623 104.948C52.2981 102.958 51.3749 99.6964 50.8107 97.6961C50.4312 96.3421 50.0311 94.9983 49.6516 93.6443C49.508 93.1417 49.3644 92.6391 49.231 92.1262C49.1695 91.8902 49.1387 91.6338 49.0567 91.3979C49.0054 91.2645 48.6464 91.0286 48.513 90.9363C47.8257 90.4029 47.2103 89.7054 46.7692 88.9565C45.7947 87.2845 45.4049 85.4074 45.9178 83.52C46.7589 80.4016 48.9951 78.0218 51.7544 76.4421C51.6519 76.2267 51.5082 76.0421 51.4057 75.8267C51.2621 75.5497 51.1492 75.2215 51.0467 74.924C50.3184 72.6263 50.6876 69.9695 51.775 67.8462C53.0982 65.2613 55.2626 63.3738 57.9706 62.5943C59.7554 62.0814 61.3864 61.0966 62.7917 59.8862C63.7149 59.0964 64.5663 58.245 64.9048 57.568C65.6434 56.0704 65.5305 54.5317 65.3972 52.9212C64.9561 47.8129 70.485 52.5417 71.9826 53.7521C74.1675 55.5062 73.8803 54.2753 76.6294 53.7419C79.5528 53.1674 81.6043 54.0598 84.9176 56.8397C85.7382 57.5269 88.3744 60.9428 88.8565 62.0916"
      stroke="#832669"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3.00425"
    />
    <path
      d="M51.5491 76.2267C51.5491 76.2267 56.2163 80.2682 64.8123 74.0828"
      stroke="#832669"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3.00425"
    />
    <path
      d="M95.9856 82.0019C95.9856 82.0019 91.9031 88.3309 83.3789 91.2338"
      stroke="#832669"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3.00425"
    />
    <path
      d="M76.6808 41.5351H74.1164C73.2383 41.5351 72.5265 42.247 72.5265 43.1251V66.0408C72.5265 66.9189 73.2383 67.6307 74.1164 67.6307H76.6808C77.5589 67.6307 78.2708 66.9189 78.2708 66.0408V43.1251C78.2708 42.247 77.5589 41.5351 76.6808 41.5351Z"
      fill="url(#paint2_linear_9_78)"
    />
    <path
      d="M79.4604 33.3495C79.4604 35.596 77.6447 37.4116 75.3983 37.4116C73.1519 37.4116 71.3363 35.596 71.3363 33.3495C71.3363 31.1031 75.3983 27 75.3983 27C75.3983 27 79.4604 31.1031 79.4604 33.3495Z"
      fill="url(#paint3_linear_9_78)"
    />
    <path
      d="M79.4604 33.3495C79.4604 35.596 77.6447 37.4116 75.3983 37.4116C73.1519 37.4116 71.3363 35.596 71.3363 33.3495C71.3363 31.1031 75.3983 27 75.3983 27C75.3983 27 79.4604 31.1031 79.4604 33.3495Z"
      stroke="#832669"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3.00425"
    />
    <path
      d="M76.6808 41.5351H74.1164C73.2383 41.5351 72.5265 42.247 72.5265 43.1251V66.0408C72.5265 66.9189 73.2383 67.6307 74.1164 67.6307H76.6808C77.5589 67.6307 78.2708 66.9189 78.2708 66.0408V43.1251C78.2708 42.247 77.5589 41.5351 76.6808 41.5351Z"
      stroke="#832669"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3.00425"
    />
  </svg>
)

export default BirthdayCupcake
